import {
  mobile,
  backend,
  creator,
  web,
  javascript,
  html,
  css,
  reactjs,
  nextjs,
  redux,
  tailwind,
  nodejs,
  mongodb,
  git,
  aperion,
  linkdin,
  gmail,
  leetcode,
  discord,
  FlickFlow,
  YouTube,
  instaClone,
  nextjsAuth,
  myBlog,
  github_explorer,
  hexon,
  supabase,
  shadcn,
  jotai,
  folderchat,
  copilot,
  graphmaker,
  featherlite,
  garnr,
  oneassist,
} from "../assets";

export const navLinks = [
  {
    id: "about",
    title: "About",
  },
  {
    id: "work",
    title: "Work",
  },
  {
    id: "contact",
    title: "Contact",
  },
  {
    id: "resume",
    title: "Resume",
  }
];

const services = [
  // {
  //   title: "Web Developer",
  //   icon: web,
  // },
  {
    title: "Frontend Developer",
    icon: mobile,
  },
  {
    title: "Backend Developer",
    icon: backend,
  },
  {
    title: "Full Stack Developer",
    icon: creator,
  },
];

const technologies = [
  {
    name: "HTML 5",
    icon: html,
  },
  {
    name: "CSS 3",
    icon: css,
  },
  {
    name: "JavaScript",
    icon: javascript,
  },
  {
    name: "React JS",
    icon: reactjs,
  },
  {
    name: "Redux Toolkit",
    icon: redux,
  },
  {
    name: "NextJS",
    icon: nextjs,
  },
  {
    name: "Shadcn",
    icon: shadcn,
  },
  {
    name: "Tailwind CSS",
    icon: tailwind,
  },
  {
    name: "Jotai",
    icon: jotai,
  },
  {
    name: "Node JS",
    icon: nodejs,
  },
  {
    name: "MongoDB",
    icon: mongodb,
  },

  {
    name: "git",
    icon: git,
  },
  {
    name: "Supabase",
    icon: supabase,
  },

];

const experiences = [
  {
    title: "Frontend Engineer I",
    company_name: "Global ITCombine (OneAssist Consumer Solutions)",
    icon: oneassist,
    iconBg: "#2C3E50",
    date: "Jan 2025 - Present",
    points: [
      "Developed and optimized core features for CRM, Unite, and OneAssist customer portals using React.js and Angular, significantly improving user experience and page performance.",
      "Built and maintained real-time admin dashboards with data visualization capabilities, streamlining internal operations and reporting workflows.",
      "Integrated and enhanced live chat bot functionalities, enabling seamless customer interactions and reducing support response times.",
      "Implemented responsive UI/UX designs across React and Angular codebases, ensuring consistent cross-device user journeys."
    ],
  },
  {
    title: "Software Engineer",
    company_name: "Aperion Tech",
    icon: aperion,
    iconBg: "#383E56",
    date: "Jan 2023 - Nov 2024",
    points: [
      "Developed Folder Chat, an AI-powered chatbot enabling users to upload files and query across data sources (GitHub, SharePoint, Gmail, Google Drive, Confluence) via natural language.",
      "Built TheGraphMaker, a SaaS chart platform supporting up to 8 customizable charts via natural language prompts, with real-time chat and Stripe subscription integration.",
      "Created a plugin-based AI chatbot that embeds into third-party websites, scrapes page content, and delivers context-aware responses with an integrated admin panel for live chat and analytics.",
      "Built Garnr.co from scratch, an AI-driven form generation platform that creates customized forms via user prompts for seamless data collection.",
      "Developed admin and sales dashboards providing real-time insights and data visualization for business operations.",
      "Designed and implemented CRUD and authentication APIs for internal dashboards, improving data management and user access control.",
      "Implemented dynamic, reusable UI components with React.js, improving usability, performance, and developer productivity."
    ],
  },
  // {
  //   title: "Search Engine Optimizer",
  //   company_name: "EwebGuide",
  //   icon: seo,
  //   iconBg: "#383E56",
  //   date: "",
  //   points: [
  //     "Identify relevant keywords and phrases that users are likely to search for in your niche or industry.",
  //     "Optimize individual web pages by incorporating keywords into titles, headings, meta descriptions, and content. Ensure proper URL structures and use of alt tags for images.",
  //     " Create high-quality, valuable, and engaging content that addresses user intent and provides solutions to their queries.",
  //     "Improve website loading times for a better user experience and improved search rankings.",
  //     "Address technical issues like broken links, duplicate content, XML sitemaps, and robots.txt to ensure search engines can crawl and index your site efficiently.",
  //     "Build High Quality Backlinks in off-page SEO to Increase the rank of our project in Google SERP's"
  //   ],
  // },


];

const testimonials = [
  {
    testimonial:
      "",
    name: "",
    designation: "",
    company: "",
    image: "",
  },
];

const projects = [
  {
    name: "Folder Chat",
    description:
      "Folder.Chat brings chat directly into your documents and tools like GitHub, Slack, Gmail and many more, making collaboration quick and seamless across your workflow.",
    tags: [
      {
        name: "nextjs",
        color: "blue-text-gradient",
      },
      {
        name: "genai",
        color: "green-text-gradient",
      },
      {
        name: "reduxjs",
        color: "pink-text-gradient",
      },
      {
        name: "shadcn",
        color: "blue-text-gradient",
      },
      {
        name: "supabase",
        color: "green-text-gradient",
      },
    ],
    image: folderchat,
    source_code: "",
    live_link: "https://demo.folder.chat"
  },
  {
    name: "The GraphMaker",
    description:
      "The GraphMaker generates custom graphs based on user prompts and features real-time chat for instant feedback and collaboration, streamlining the process of data visualization.",
    tags: [
      {
        name: "nestjs",
        color: "blue-text-gradient",
      },
      {
        name: "shadcn",
        color: "green-text-gradient",
      },
      {
        name: "tailwindcss",
        color: "pink-text-gradient",
      },
      {
        name: "supabase",
        color: "blue-text-gradient",
      },
      {
        name: "nodemailer",
        color: "green-text-gradient",
      },
      {
        name: "reactcharts",
        color: "pink-text-gradient",
      },
    ],
    image: graphmaker,
    source_code: "",
    live_link: "https://thegraphmaker.com/"
  },
  {
    name: "Copilot Chat Bot",
    description:
      "This chatbot plugin allows users to ask questions, search for products, and access detailed information directly through the popup, making browsing and shopping more efficient.",
    tags: [
      {
        name: "vitereact",
        color: "blue-text-gradient",
      },
      {
        name: "shadcn",
        color: "green-text-gradient",
      },
      {
        name: "reduxjs",
        color: "pink-text-gradient",
      },
      {
        name: "tailwindcss",
        color: "blue-text-gradient",
      },
    ],
    image: copilot,
    source_code: "",
    live_link: "https://copilot-chat-bot.vercel.app/"
  },
  {
    name: "FeatherLite",
    description:
      "Featherlite simplifies secure LLM deployments, allowing organizations to efficiently manage private models with optimized cost and performance.",
    tags: [
      {
        name: "astro",
        color: "blue-text-gradient",
      },
      {
        name: "html",
        color: "green-text-gradient",
      },
      {
        name: "tailwindcss",
        color: "pink-text-gradient",
      },
      {
        name: "javascript",
        color: "blue-text-gradient",
      },
    ],
    image: featherlite,
    source_code: "",
    live_link: "https://www.featherlite.ai/"
  },
  {
    name: "Garnr",
    description:
      "Garnr uses conversational AI to moderate voice forms and surveys, making data collection more interactive and engaging. ",
    tags: [
      {
        name: "vitereact",
        color: "blue-text-gradient",
      },
      {
        name: "shadcn",
        color: "pink-text-gradient",
      },
      {
        name: "tailwindcss",
        color: "green-text-gradient",
      },
    ],
    image: garnr,
    source_code: "",
    live_link: "https://demo.garnr.co/"
  },
  {
    name: "Flick Flow",
    description:
      "A web platform for users to sign up, sign in, search, upload, view, and edit videos easily.",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "mongodb",
        color: "green-text-gradient",
      },
      {
        name: "reduxjs",
        color: "pink-text-gradient",
      },
      {
        name: "restapi",
        color: "blue-text-gradient",
      },
      {
        name: "expressjs",
        color: "green-text-gradient",
      },
    ],
    image: FlickFlow,
    source_code: "https://github.com/ttarunn/video-sharing-app",
    live_link: "https://flickflow.netlify.app/"
  },
  {
    name: "YouTube Clone",
    description:
      "YouTube Frontend Layer using youtube API's and implemented routes, Search API, Live Chat and nested comments etc.",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "reduxjs",
        color: "green-text-gradient",
      },
      {
        name: "tailwind",
        color: "pink-text-gradient",
      },
    ],
    image: YouTube,
    source_code: "https://github.com/ttarunn/youtube-clone",
    live_link: "https://utube-dummy.netlify.app/"
  },
  {
    name: "My Blog - Real Time Editor",
    description:
      "Seamlessly craft, edit, and share your thoughts with our user-friendly platform. Experience hassle-free, real-time blogging that puts your creativity in the spotlight.",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "appwrite",
        color: "green-text-gradient",
      },
      {
        name: "reduxjs",
        color: "pink-text-gradient",
      },
      {
        name: "tailwind",
        color: "blue-text-gradient",
      }
    ],
    image: myBlog,
    source_code: "https://github.com/ttarunn/blog-project-appwrite",
    live_link: "https://blogbuzz.vercel.app/"
  },

];
const social = [{
  name: "LinkeDin",
  image: linkdin,
  source_link: "https://www.linkedin.com/in/ittarunn/"
},
{
  name: "Email",
  image: gmail,
  source_link: "mailto: ttarunn0709@gamil.com"
},
{
  name: "Leetcode",
  image: leetcode,
  source_link: "https://leetcode.com/ittarunn/"
},
{
  name: "Discord",
  image: discord,
  source_link: "https://discordapp.com/users/947866702568382475"
}
]

export { services, technologies, experiences, testimonials, projects, social };
